import dayjs from 'app/config/dayjsConfig';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { actionIconMapper, actionTitleMapper, HistoryAction } from 'entities/History';
import { OpenValidationErrorActionNames } from 'entities/History/model/types';
import { FC, memo, ReactElement } from 'react';

interface HistoryActionRowProps {
  data: HistoryAction;
  loggedUserEmail: string | undefined;
}

export const HistoryActionRow: FC<HistoryActionRowProps> = memo((props) => {
  const {
    data: { actionName, actionData, createdAt, updatedAt },
    loggedUserEmail,
  } = props;

  const { t } = useAppTranslation('profile');

  const isErrorAction = Object.values(OpenValidationErrorActionNames).includes(actionName as OpenValidationErrorActionNames);

  const getActionTitle = (): ReactElement => {
    const { subject, action, object } = actionTitleMapper(actionName, actionData, t);

    const subjectName = subject === loggedUserEmail ? t('You') : subject;

    const layout = (): ReactElement => {
      return (
        <div className="font-normal">
          <span className="font-medium">{subjectName}</span> <span className={isErrorAction ? 'text-warn' : 'text-accent'}>{action}</span>{' '}
          <span className="text-accent">{object}</span>
        </div>
      );
    };

    return layout();
  };

  const lastUpdateTime = dayjs(updatedAt || createdAt).fromNow();

  const actionIcon = actionIconMapper(actionName);

  return (
    <div className="flex items-center space-x-4">
      {actionIcon}
      <div className="flex flex-col">
        {getActionTitle()}
        <div className="text-sm text-primaryLight">{lastUpdateTime}</div>
      </div>
    </div>
  );
});
